export interface ConfigPageComponent {
    link: string;
    showHeader?: boolean;
    modePage?: ModePage;
}

export enum ModePage {
    BaseComponent,
    ExportedInOtherPlatform,
}
